import useSite from "../features/permits/components/inspections/InspectionPanel/useSite";
import { getAccessToken } from "../lib/auth";

export default function useNetworkHeaders() {
  const site = useSite();
  const headers = {
    "Content-Type": "application/json",
    "Authorization": getAccessToken(),
    "X-GOGOVAPPS-SITE": site,
  };
  return headers;
}
